import Plan from "./Plan";
import "./Plan.css";

export default Plan